// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.ferm_text_input_mode_enum */
var FermTextInputModeEnum;
(function (FermTextInputModeEnum) {
    FermTextInputModeEnum["FREE_TEXT"] = "FREE_TEXT";
    FermTextInputModeEnum["DROPDOWN"] = "DROPDOWN";
    FermTextInputModeEnum["AUTOCOMPLETE"] = "AUTOCOMPLETE";
})(FermTextInputModeEnum || (FermTextInputModeEnum = {}));
;
export default FermTextInputModeEnum;
/** Zod schema for ferm_text_input_mode_enum */
export const fermTextInputModeEnum = z.nativeEnum(FermTextInputModeEnum);
//# sourceMappingURL=FermTextInputModeEnum.js.map